module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"aaron-psersonal-web","short_name":"aaronweb","start_url":"/","background_color":"#EB5757","theme_color":"#EB5757","display":"minimal-ui","icon":"src/images/at-hi-logo.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"c4426f708d2f57327a36637382975282"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
